module.exports = [
  {
    id: 'v1',
    name: 'v1'
  },
  {
    id: 'v2',
    name: 'v2'
  },
  {
    id: 'v3',
    name: 'v3'
  }
]
